import Vue from 'vue';
import {DataService} from "@/service/data";
import {AuthService} from "@/service/auth";

const state = {};

const getters = {};

const actions = {
    getApiToken() {
        return DataService.getApiToken();
    },

    getCurrentSubscription() {
        return DataService.getCurrentSubscription();
    },

    async getCurrentResidentialSubscription() {
        try {
            const response = await DataService.getCurrentResidentialSubscription();
            return response.data;
        } catch (error) {
            return {};
        }
    },

    async getCurrentDatacenterSubscription() {
        try {
            const response = await DataService.getCurrentDatacenterSubscription();
            return response.data;
        } catch (error) {
            return {};
        }
    },

    async getResidentialCredentials () {
        try {
            const response = await AuthService.get_residential_credentials();
            return response.data;
        } catch (error) {
            return {};
        }
    },

    async getDatacenterCredentials () {
        try {
            const response = await AuthService.get_datacenter_credentials();
            return response.data;
        } catch (error) {
            return {};
        }
    },

    resetResidentialCredentials() {
        return AuthService.reset_residential_credentials();
    },

    resetDatacenterCredentials() {
        return AuthService.reset_datacenter_credentials();
    },

    changePassword(ctx, params) {
        return AuthService.change_password(params);
    },

    generateAndGetNewApiToken() {
        return DataService.generateNewApiToken()
            .then(() => DataService.getApiToken());
    },

    removeAccount() {
        return AuthService.delete_user()
            .then(() => Vue.auth.logout())
            .then(() => Vue.router.push({name: 'Login'}));
    },
};

const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
